/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ReactElement } from "react";
import { DraggableProvided } from "react-beautiful-dnd";
import { ToggleItemBox, Wrap } from "~/components";
import { getActionDisplayName } from "~/views/plans/utils";
import { PlanEntity, SelectedPlanEntity } from "../../types";

type Props = {
  item: PlanEntity;
  isActive: boolean;
  provided: DraggableProvided;
  editableName?: ReactElement;
  onMouseDown: (item: SelectedPlanEntity) => void;
  onDelete?: () => void;
};

export function ActionItemEdit({
  item,
  isActive,
  provided,
  editableName,
  onMouseDown,
  onDelete,
}: Props) {
  const displayName = getActionDisplayName(
    item.name ?? "",
    item.action?.name || item.actionName || "",
    item.actionType
  );

  return (
    <Wrap css={{ "& > div": { width: "100%" } }}>
      <ToggleItemBox
        active={isActive}
        provided={provided}
        item={{
          id: item.id ?? "",
          color: item.color ?? "",
          name: editableName ?? displayName,
          actionType: item.actionType,
          icon: item.icon,
          onMouseDown: () => onMouseDown(item),
          onDelete: onDelete,
        }}
      />
    </Wrap>
  );
}
